<div class="table-info">
  <nz-alert [nzType]="'info'" *ngIf="_config.showSelectTip" [nzShowIcon]="_config.showSelectTip" [nzMessage]="message">
    <ng-template #message>
      <div style="float: left;" *ngIf="_config.showSelectTip">
        {{"已选择"|translate}}
        <strong class="text-primary">&nbsp;{{_config.checkedlength}}&nbsp;</strong> {{"项"|translate}}&nbsp;&nbsp;
        <a *ngIf="_config.checkedlength>0" class="ml-lg" (click)="onAllChecked(false)"> {{"清空"|translate}}</a>
      </div>

      <div style="text-align: right;" >
        <ng-container>
          {{"总记录"|translate}}
          <strong class="text-primary">&nbsp;{{_config.pagerInfo.dataCount}}&nbsp;</strong>
          {{"项"|translate}}&nbsp;&nbsp;
        </ng-container>
      </div>
    </ng-template>
  </nz-alert>
</div>
<nz-table class="app-table" ngDefaultcontrol #rowSelectionTable [nzShowPagination]="_config.showPagination"
  nzShowSizeChanger nzSize="small" [nzFrontPagination]="false" [nzLoading]="_config.loading"
  [nzTotal]="_config.pagerInfo.dataCount" [nzPageSize]="_config.pagerInfo.pageSize"
  [nzScroll]="{ y:_config.y_Scroll+'px'}" [nzPageIndex]="_config.pagerInfo.pageIndex" [nzData]="_config.dataSource"
  (nzQueryParams)="onQueryParamsChange($event)">
  <thead>
    <tr class="ant-table-tbody-row">
      <th [nzWidth]="'60px'" [nzShowCheckbox]="_config.checkBox" [nzChecked]="_config.checkedAll"
        [nzIndeterminate]="_config.indeterminate" (nzCheckedChange)="onAllChecked($event)">
      </th>
      <th nz-resizable nzPreview nzBounds="window" [nzMaxWidth]="1000" (nzResizeEnd)="onResize($event,item)"
        [nzWidth]="item.width" [nzCustomFilter]="item.search" *ngFor="let item of  _config.columes"
        [nzColumnKey]="item.dataIndex" [nzSortFn]="true" [nzShowSort]="item.sort" [nzSortOrder]="item.sortOrder"
        [nzFilterFn]="true" [nzShowFilter]="item.listOfFilter&&item.listOfFilter.length>0"
        [nzFilters]="item.listOfFilter" [nzFilterMultiple]="item.filterMultiple" (nzFilterChange)="filterChange(item,$event)">
        {{item.header|translate}}
        <nz-resize-handle nzDirection="right">
          <div class="resize-trigger"></div>
        </nz-resize-handle>
        <nz-filter-trigger *ngIf="item.search" [(nzVisible)]="item.searchVisible" [nzActive]="item.searchValue"
          [nzDropdownMenu]="menu">
          <i nz-icon nzType="search"></i>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <div class="ant-table-filter-dropdown">
              <div class="search-box">
                <input type="text" nz-input placeholder="Search" [(ngModel)]="item.searchValue" />
                <button nz-button nzSize="small" nzType="primary" (click)="columeSearch(item)" class="search-button">
                  {{"查询"|translate}}
                </button>
                <button nz-button nzSize="small" (click)="resetColumeSearch(item)"> {{"重置"|translate}}</button>
              </div>
            </div>
          </nz-dropdown-menu>
        </nz-filter-trigger>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of rowSelectionTable.data" [ngClass]="{'row-select':item.selectstate&&!_config.checkBox}"
      (click)="onRowClick(item)">
      <td [nzDisabled]="item.Disable" [nzShowCheckbox]="_config.checkBox" [nzChecked]="item.selectstate"
        (nzCheckedChange)="onItemChecked(item, $event)"></td>
      <td *ngFor="let headItem of _config.columes" (click)="onCellClick(item,headItem)">
        <span *ngIf="!headItem.render; else elseBlock"
          [title]="(!headItem.buttons?item[headItem.dataIndex]:'操作')|translate">
          <ng-container *ngIf="!headItem.buttons; else renderButtons">
            {{headItem.format?headItem.format(item):item[headItem.dataIndex]|translate}}
          </ng-container>

          <ng-template #renderButtons>
            <ng-container *ngIf="item.Disable; else blankButtons">
              <span>已完成</span>
            </ng-container>
            <ng-template #blankButtons>
              <ng-container *ngFor="let btn of headItem.buttons let i = index">
                <a *ngIf="!btn.confirm; else renderconfirmbtn"
                  (click)="btn.click(item,headItem)">{{btn.text|translate}}</a>
                <nz-divider *ngIf="i<headItem.buttons.length-1" nzType="vertical"></nz-divider>
                <ng-template #renderconfirmbtn>
                  <ng-container>
                    <a nz-popconfirm nzPopconfirmTitle="{{(btn.confirmTitle?btn.confirmTitle:'是否确认操作选中行')|translate}}"
                      (nzOnConfirm)="btn.click(item,headItem)">{{"删除"|translate}}</a>
                  </ng-container>
                </ng-template>
              </ng-container>
            </ng-template>
          </ng-template>
        </span>
        <ng-template #elseBlock [ngTemplateOutlet]="this.renderService.getRow(headItem.render)"
          [ngTemplateOutletContext]="{ $implicit: item, colume:headItem}">
        </ng-template>
      </td>

    </tr>
  </tbody>
</nz-table>